import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SITE } from "@/lib/site";

export default function QuoteCTA({ compact = false }) {
  return (
    <section
      data-testid="quote-cta"
      className={`relative ${compact ? "py-16" : "py-20 md:py-28"} bg-blue-700 overflow-hidden`}
    >
      <div className="absolute inset-0 grain opacity-30" aria-hidden="true" />
      <div className="absolute -right-20 -top-20 w-80 h-80 rounded-full bg-orange-500/20 blur-3xl" aria-hidden="true" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-8">
            <h2 className="font-display font-bold tracking-tight text-white text-3xl sm:text-4xl lg:text-5xl">
              Ready for a parking lot you're proud of?
            </h2>
            <p className="mt-4 text-base sm:text-lg text-blue-100 max-w-2xl leading-relaxed">
              Tell us about your lot in 60 seconds. We'll come walk the
              site and send a fixed-price quote — usually within 48 hours.
            </p>
          </div>
          <div className="lg:col-span-4 flex flex-col sm:flex-row lg:flex-col items-stretch gap-3">
            <Button
              asChild
              size="lg"
              data-testid="cta-free-quote"
              className="bg-orange-600 hover:bg-orange-700 text-white font-semibold text-base px-7 py-6 rounded-md justify-center"
            >
              <Link to="/quote">
                Request Free Quote <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </Button>
            <Button
              asChild
              variant="outline"
              size="lg"
              data-testid="cta-call"
              className="bg-transparent text-white border-white/40 hover:bg-white hover:text-blue-700 font-semibold text-base px-7 py-6 rounded-md justify-center"
            >
              <a href={SITE.phoneHref}>
                <Phone className="mr-2 h-5 w-5" /> Call {SITE.phone}
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
